import gql from 'graphql-tag'


export const CLIENT_ASSESSMENTS_QUERY = gql`
query userCheckIns($userId: ID!, $decodedId: ID!, $type: String, $startDate: Date, $endDate: Date) {
  userCheckIns(userId: $userId, type: $type, assessmentDate_Gte: $startDate, assessmentDate_Lte: $endDate){
    edges {
      node {
        id
        weight
        abdomen
        chest
        hip
        quad
        oneMile
        pushUps
        sitUps
        burpeeChirpee
        elbowPlank
        squat
        imgFront
        imgBack
        imgSide
        rating
        comments
        nutritionRating
        nutritionComments
        createdAt
        type
        assessmentDate
        requiredDate
        user {
          id
          firstName
          lastName
        }
        notes {
          id
          note
          createdAt
          updatedAt
          coach {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  client(id: $decodedId) {
    firstName
    lastName
  }
}
`

export const CLIENT_CURRENT_ASSESSMENTS_QUERY = gql`
query clientAssessments($userId: ID!) {
  client(id: $userId) {
    firstName
    lastName
    ticketId
    hubspotPortalId
    hubspotTicketId
  }
  
  currentClientAssessments(userId: $userId){
    id
		number
    userProgram {
      id
      user {
        firstName
        lastName
      }
    }
    requiredDate
    assessmentDate
    weight
    abdomen
    chest
    hip
    quad
    note
    imgFront
    imgBack
    imgSide
    calendlyUuid
    notes {
      id
      note
      createdAt
      updatedAt
      coach {
        firstName
        lastName
      }
    }
  } 
}
`

export const CREATE_ASSESSMENTS_RECORD_QUERY = gql`
mutation createAssessmentRecord($requiredDate: String!, $userId: ID!) {
  createAssessmentRecord(requiredDate: $requiredDate, userId: $userId){
    error
    created
  } 
}
`


export const USER_MEASUREMENTS_QUERY = gql`
query measurementsQuery($userId: ID!) {
  measurements(userId: $userId) {
    edges {
      node {
        id
        weight
        abdomen
        chest
        hip
        quad
        imgFront
        imgBack
        imgSide
        createdAt
        user {
          id
        }
      }
    }
  }
}
`

export const ASSESSMENT_QUERY = gql`
query userCheckIn($id: ID!){
  userCheckIn(id: $id) {
      id
      requiredDate
      assessmentDate
      weight
      abdomen
      chest
      hip
      quad
      imgFront
      imgBack
      imgSide
      calendlyUuid
      notes {
        id
        note
        createdAt
        updatedAt
        coach {
          id
          firstName
          lastName
        }
      }
    }
  }
`
